/**
 * Formats member warehouse name list for table cells.
 */
export function formatMemberWarehouseLabels(names?: string[]): string {
  if (!names?.length) return '-';
  return names.join(', ');
}
